export const NUM_GRID_COLUMNS = 24;

export const DEFAULT_INPUT_LABEL_SPAN = 4;
